import { api } from './baseUrl';

/**
 * Service pour gérer les fichiers achetés
 */
class PurchasedFilesService {
  /**
   * Récupérer la liste des fichiers achetés de l'utilisateur
   */
  async getMyFiles() {
    try {
      const response = await api.get('/purchased-files');
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des fichiers achetés:', error);
      throw error;
    }
  }

  /**
   * Télécharger un fichier acheté
   * @param {number} fileId - ID du fichier à télécharger
   */
  async downloadFile(fileId) {
    try {
      const response = await api.get(`/purchased-files/${fileId}/download`, {
        responseType: 'blob' // Important pour télécharger des fichiers binaires
      });

      // Récupérer le nom du fichier depuis les headers de la réponse
      const contentDisposition = response.headers['content-disposition'];
      let filename = 'fichier_telecharge';
      
      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="(.+)"/);
        if (filenameMatch && filenameMatch[1]) {
          filename = filenameMatch[1];
        }
      }

      // Créer un lien temporaire pour télécharger le fichier
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      
      // Nettoyer
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);

      return true;
    } catch (error) {
      console.error('Erreur lors du téléchargement du fichier:', error);
      throw error;
    }
  }
}

export default new PurchasedFilesService();
